import Vue from "vue"
import { Card,Row,Col,Menu,MenuItem,RadioGroup,RadioButton,DatePicker,Table,TableColumn,Pagination} from "element-ui"
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
